import React from "react";
import {Container, Navbar, Progress} from "reactstrap";
import logo from "../../assets/img/brand/ace-logo.png";

const CandidateHeader = (props) => {
  return (
      <>
        <Navbar color="dark" dark expand="md" className="new-bg">
          <Container className="assessment-main-container">
            <div
                className="pr-5"
                role="button"
                onClick={() => {
                  window.location.reload();
                }}
            >
              <img src={logo} alt=""/>
            </div>
            {/*<NavbarToggler onClick={toggle}/>*/}
            <div className="d-none d-lg-block d-md-block">
            <span className="fs-14 text-white ml-3 font-weight-600">
              {" "}
              {Math.round(props.progress)}% to complete
            </span>
              <div className="assessment-loading-wrapper">
                <Progress
                    // striped
                    bar
                    className="py-1 rounded-pill"
                    value={props.progress}
                ></Progress>
              </div>
            </div>
            <div className="d-lg-none d-md-none d-block">
            <span className="fs-14 text-white ml-3 font-weight-600">
              {" "}
              {Math.round(props.progress)}% to complete
            </span>
              <div className="assessment-loading-wrapper">
                <Progress
                    bar
                    className="py-1 rounded-pill"
                    value={props.progress}
                ></Progress>
              </div>
            </div>
          </Container>
        </Navbar>

        {/*<Navbar dark className="d-lg-none" style={{backgroundColor: "#04A1FE"}}>*/}
        {/*    <div>*/}
        {/*        <img src={logo} onClick={() => props.switchComponent('greetings')}/>*/}
        {/*    </div>*/}
        {/*    <div className="w-100 mt-2 text-center">*/}
        {/*        <span className={"text-white"}>Progress</span>*/}
        {/*        <div className="loading-wrapper">*/}
        {/*            <Progress*/}
        {/*                className="mb-0"*/}
        {/*                color="loading-bg"*/}
        {/*                value={20}*/}
        {/*            />*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</Navbar>*/}
        {/*<Container className="pt-3 d-none d-lg-block" fluid>*/}
        {/*    <div className="w-100 candidate-header-wrapper">*/}
        {/*        <div className="main-wrapper">*/}
        {/*            <Row className="mt-3">*/}
        {/*                <Col lg={9}>*/}
        {/*                    <img src={logo} alt="" role="button"*/}
        {/*                         onClick={() => props.switchComponent('greetings')}/>*/}
        {/*                </Col>*/}
        {/*                <Col lg={3}>*/}
        {/*                    <div className={"d-flex justify-content-between"}>*/}
        {/*                        <span className={"text-white"}>Progress</span>*/}
        {/*                        <span className={"text-white"}>{props.step} of 6 Steps</span>*/}
        {/*                    </div>*/}
        {/*                    <div className="loading-wrapper">*/}
        {/*                        <Progress*/}
        {/*                            className="mb-0"*/}
        {/*                            color="loading-bg"*/}
        {/*                            value={props.progress}*/}
        {/*                        />*/}
        {/*                    </div>*/}
        {/*                </Col>*/}
        {/*            </Row>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</Container>*/}
      </>
  );
};

export default CandidateHeader;
